import { HelpersService } from 'src/app/services/helpers.service';
import { DatabaseService } from './database.service';
import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { auth } from 'firebase/app';
import { Router } from '@angular/router';

import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

import { Observable, of } from 'rxjs';
import { switchMap, first, shareReplay } from 'rxjs/operators';
import { User, UserProfile } from '../models/user.model';
import { Hackathon } from '../models/hackathon.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private user$: Observable<any>;

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
    private helper: HelpersService,
    private database: DatabaseService) {
    this.user$ = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges().pipe(shareReplay(1));
        } else {
          return of(null);
        }
      })
    );
  }

  get getUser() {
    return this.user$.pipe(first()).toPromise();
  }

  // Cria popUp de login com o google
  async googleSignin() {
    const provider = new auth.GoogleAuthProvider();
    const credential = await this.afAuth.auth.signInWithPopup(provider);
    this.capturarUserProfile(credential.user);
  }

  capturarUserProfile({ uid, email, displayName, photoURL }: UserProfile) {
    // Captura os dados
    const userProfile: UserProfile = {
      uid,
      email,
      displayName,
      photoURL
    };
    this.updateUserProfileToUserData(userProfile);
  }

  // Faz login e redireciona para a pagina de login
  async signOut() {
    await this.afAuth.auth.signOut();
    this.routeToLogin();
  }

  // Insere os dados do usuario no firestore
  private updateUserProfileToUserData(userProfile: UserProfile) {
    // Captura Referencia do documento no firestore
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${userProfile.uid}`);

    const usr: any = userRef.get();
    usr.subscribe(user => {
      const userDocument: any = user.data();

      let userData: User = this.userDataInitializer();

      if (this.helper.isNullOrUndefined(userDocument)) {
        // para novos usuarios
        userData.user = userProfile;
        userData.perfis = [];
        userData.admin = false;
        userData.licenca = '';
        userRef.set(userData, {merge: true}); // faz o merge com os dados existentes
      } else {
        if (this.helper.isNullOrUndefined(userDocument.user)) {
          userData.user = userProfile;
        } else {
          userData.user = userProfile;
        }

        if (this.helper.isNullOrUndefined(userDocument.perfis)) {
          userData.perfis = [];
        } else {
          userData.perfis = userDocument.perfis;
        }

        if (this.helper.isNullOrUndefined(userDocument.admin)) {
          userData.admin = false;
        } else {
          userData.admin = userDocument.admin;
        }

        if (this.helper.isNullOrUndefined(userDocument.licenca)) {
          userData.licenca = '';
        } else {
          userData.licenca = userDocument.licenca;
        }

        // Atualiza a base, mas so atualiza os dados alterados
        if (this.helper.isNullOrUndefined(userDocument.user)
            || this.helper.isNullOrUndefined(userDocument.perfis)
            || this.helper.isNullOrUndefined(userDocument.admin)
            || this.helper.isNullOrUndefined(userDocument.licenca)) {
          userRef.set(userData, {merge: false}); // força a substituição dos dados, no caso dos usuarios da versao 2
        } else {
          userRef.set(userData, {merge: true}); // faz o merge com os dados existentes
        }
      }
    });
  }

  addPerfil(hackathonId: string, perfil: number) {
    this.getUser.then((user: User) => {
      const perfilIndex = user.perfis.findIndex(p => p.hackathonId === hackathonId);

      if (perfilIndex > 0) {
        user.perfis[perfilIndex].perfil = perfil;
      } else {
        user.perfis.push({
          hackathonId,
          perfil
        });
      }

      this.updateUserData(user);
    });
  }

  changePerfil(hackathonId: string, perfil: number) {
    this.getUser.then((user: User) => {
      const oldPerfilIndex = user.perfis.findIndex(p => p.hackathonId === hackathonId);
      user.perfis[oldPerfilIndex].perfil = perfil; // muda para o novo perfil
      this.updateUserData(user);
    });
  }

  private updateUserData(userData: User) {
    // Captura Referencia do documento no firestore
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${userData.user.uid}`);

      // Atualiza a base, mas so atualiza os dados alterados
    userRef.set(userData, {merge: true}); // faz o merge com os dados existentes
  }

  /// Guards ///

  async authGuard() {
    this.user$.subscribe(data => {
      if (this.helper.isNullOrUndefined(data)
          || this.helper.isNullOrUndefined(this.helper.hackathonNome)) {
        this.routeToLogin();
      }
    });
  }

  /// Routers ///
  async routeToDetalhesHackathonsWithGoogleLogin(codigoAcessoHackathon) {
    await this.googleSignin();
    this.database.buscarHackathonPorCodigoAcesso(codigoAcessoHackathon)
    .then(data => {
      data.subscribe((hackathons: Hackathon[]) => {

        if (!this.helper.isNullOrUndefined(hackathons) && hackathons.length > 0) {
          this.helper.openSnackBar('Hackathon encontrado, aguarde alguns segundos!!', 'OK');
          const hackathon: Hackathon = hackathons.find(hack => hack.codigoAcesso === codigoAcessoHackathon);
          this.helper.setHackathon(hackathon);
          this.helper.routeToDetalhes();
        } else {
          this.helper.openSnackBar('Hackathon não encontrado!!', 'OK');
          this.routeToLogin();
        }

      });
    });
  }

  routeToLogin() {
    return this.router.navigate(['/']);
  }

  userDataInitializer(): User {
    return {
      user: {
        displayName: '',
        email: '',
        photoURL: '',
        uid: ''
      },
      perfis: [],
      admin: false,
      licenca: ''
    };
  }
}
